
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexaAs6F0uOO1PbNxqH8DD_45e04gSZQCarVD9TCXJYV94KEMeta } from "/opt/build/repo/pages/index.vue?macro=true";
import { default as indexE1jTtt_45ErFQOxvwDaDn_45msN6yt0ToOEAeyVnAMrsChQMeta } from "/opt/build/repo/pages/hobbies/index.vue?macro=true";
import { default as indexJxu2jFkvSCWJf6gZ2nAdBaEA0U3aznS_LcN5i2h40XgMeta } from "/opt/build/repo/pages/projects/index.vue?macro=true";
import { default as indexziMPP3pd4MNHLOhzv7jvwW_XLSJD7wp58LqtG4ArJZwMeta } from "/opt/build/repo/pages/experiences/index.vue?macro=true";
import { default as _91_46_46_46slug_93Z4CspHxAldADxzP4cTFYFN_45ia728BgXWU_qp1UcIThMMeta } from "/opt/build/repo/pages/hobbies/[...slug].vue?macro=true";
import { default as indexbySlHsxgh5R0IPiK4y5fmC6AdS73sGuA_45UMHxWa9N4sMeta } from "/opt/build/repo/pages/publications/index.vue?macro=true";
import { default as _91_46_46_46slug_93RFZ5xsV_45Wu7BhfNWGZTDxLyY_LbpBb8As3fh0nsixHUMeta } from "/opt/build/repo/pages/publications/[...slug].vue?macro=true";
export default [
  {
    name: "index___it",
    path: "/",
    component: () => import("/opt/build/repo/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/opt/build/repo/pages/index.vue")
  },
  {
    name: "index___es",
    path: "/es",
    component: () => import("/opt/build/repo/pages/index.vue")
  },
  {
    name: "hobbies___it",
    path: "/hobbies",
    component: () => import("/opt/build/repo/pages/hobbies/index.vue")
  },
  {
    name: "hobbies___en",
    path: "/en/hobbies",
    component: () => import("/opt/build/repo/pages/hobbies/index.vue")
  },
  {
    name: "hobbies___es",
    path: "/es/hobbies",
    component: () => import("/opt/build/repo/pages/hobbies/index.vue")
  },
  {
    name: "projects___it",
    path: "/projects",
    component: () => import("/opt/build/repo/pages/projects/index.vue")
  },
  {
    name: "projects___en",
    path: "/en/projects",
    component: () => import("/opt/build/repo/pages/projects/index.vue")
  },
  {
    name: "projects___es",
    path: "/es/projects",
    component: () => import("/opt/build/repo/pages/projects/index.vue")
  },
  {
    name: "experiences___it",
    path: "/experiences",
    component: () => import("/opt/build/repo/pages/experiences/index.vue")
  },
  {
    name: "experiences___en",
    path: "/en/experiences",
    component: () => import("/opt/build/repo/pages/experiences/index.vue")
  },
  {
    name: "experiences___es",
    path: "/es/experiences",
    component: () => import("/opt/build/repo/pages/experiences/index.vue")
  },
  {
    name: "hobbies-slug___it",
    path: "/hobbies/:slug(.*)*",
    component: () => import("/opt/build/repo/pages/hobbies/[...slug].vue")
  },
  {
    name: "hobbies-slug___en",
    path: "/en/hobbies/:slug(.*)*",
    component: () => import("/opt/build/repo/pages/hobbies/[...slug].vue")
  },
  {
    name: "hobbies-slug___es",
    path: "/es/hobbies/:slug(.*)*",
    component: () => import("/opt/build/repo/pages/hobbies/[...slug].vue")
  },
  {
    name: "publications___it",
    path: "/publications",
    component: () => import("/opt/build/repo/pages/publications/index.vue")
  },
  {
    name: "publications___en",
    path: "/en/publications",
    component: () => import("/opt/build/repo/pages/publications/index.vue")
  },
  {
    name: "publications-slug___it",
    path: "/publications/:slug(.*)*",
    component: () => import("/opt/build/repo/pages/publications/[...slug].vue")
  },
  {
    name: "publications-slug___en",
    path: "/en/publications/:slug(.*)*",
    component: () => import("/opt/build/repo/pages/publications/[...slug].vue")
  }
]